module.exports = __webpack_public_path__ + "img/car-location.0a89d969.png";